import React, { useState, useEffect } from "react";
import { TSearchProps } from "../../types/Search";

const Search = ({ value , placeholder, handleSearchParams, searchWidth, showSearchButton = false }: TSearchProps) => {
  const [searchValue, setSearchValue] = useState('');
  const [debouncedValue, setDebouncedValue] = useState('');


   useEffect(() => {
    if (value !== undefined) {
      setSearchValue(value);
    }
  }, [value])

  // Debounce effect for non-product modules
  useEffect(() => {
    if (!showSearchButton && searchValue !== '') {
      const timer = setTimeout(() => {
        setDebouncedValue(searchValue);
      }, 800);

      return () => clearTimeout(timer);
    } else if (!showSearchButton && searchValue === '') {
      // Clear search when input is empty
      setDebouncedValue('');
      typeof handleSearchParams === 'function' && handleSearchParams('');
    }
  }, [searchValue, showSearchButton]);

  // Handle debounced search for non-product modules
  useEffect(() => {
    if (!showSearchButton && debouncedValue !== '') {
      typeof handleSearchParams === 'function' && handleSearchParams(debouncedValue);
      // Clear the debounced value after search
      setDebouncedValue('');
    }
  }, [debouncedValue, showSearchButton, handleSearchParams]);

  const handleSearch = () => {
    if (searchValue !== '') {
      typeof handleSearchParams === 'function' && handleSearchParams(searchValue);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (showSearchButton && e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  return (
    <div className="d-flex align-items-center">
      <div className="position-relative me-2">
        <span className="position-absolute top-50 translate-middle-y ms-4">
          <i className="bi bi-search fs-5"></i>
        </span>
        <input
          type='text'
          data-kt-user-table-filter='search'
          className='form-control form-control-solid ps-11'
          style={searchWidth ? { width: searchWidth } : { width: '250px' }}
          placeholder={placeholder}
          value={searchValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
      </div>
      {showSearchButton && (
        <button
          className="btn btn-primary"
          onClick={handleSearch}
        >
          Search
        </button>
      )}
    </div>
  );
};

export default Search;
